import { SidebarItemsType } from "../../types/sidebar";

import { Grid } from "react-feather";

const pagesSection = [
  {
    href: "/",
    icon: Grid,
    title: "Dashboard",
  },
] as SidebarItemsType[];

const navItems = [
  {
    title: "Audittrail",
    pages: pagesSection,
  },
  /* {
    title: "Settings",
    pages: settingSection,
  }, */
];

export default navItems;
